export * from '@core/js/components/common/Button/constants';

export enum VIEWS {
    primary = 'primary',
    secondary = 'secondary',
    readonly = 'readonly',
    tertiary = 'tertiary',
    quaternary = 'quaternary',
    link = 'link',
    diamond = 'diamond',
    primaryInverted = 'primaryInverted'
}

export const NATIVE_APP_MAP = {
    iosBingo: '1658280594',
    androidBingo: 'com.buzzbingo.buzzgroup',
    iosCasino: '6467188412',
    androidCasino: 'com.buzzcasino.buzzgroupltd'
};

export const PRE_SCREENING_DELAY = 300;
